export enum ContentType {
  IMAGE_OR_VIDEO = 'IMAGE_OR_VIDEO',
  IMAGE = 'IMAGE',
  VIDEO = 'VIDEO',
  OTHER = 'OTHER',
}